export const h = {
	quantity: "inventaris",
	brand: "merek",
	sku: "SKU",
	model: "Model",
	addCart: "Tambahkan ke Keranjang",
	buyNow: "Beli Sekarang",
	productDetail: "Detail Produk",
	attribute: "Atribut",
	quantityExits: "persediaan",
	quantityNone: "Stok habis",

	// 账单页面
	email: "Email",
	errorEmail: "Silakan masukkan email yang benar",
	contact: 'Informasi kontak',
	sippingAddress: 'Alamat pengiriman',
	name: "Nama",
	nameError: "Silakan masukkan nama",
	address1: "Alamat1",
	address1Error: "Silakan masukkan alamat1",

	address2: "Alamat2",
	emailCode: "Kode pos",

	phone: "Nomor telepon",
	city: "Kota",
	cityError: "Silakan masukkan kota",
	country: "Negara",
	countryError: "Silakan masukkan negara",
	province: "provinsi",
	provinceError: "Silakan masukkan provinsi",
	payWay: "Metode pembayaran",
	sendWay: "Metode pengiriman",
	loginText: "Masuk / Daftar",
	cartNum: "Jumlah total keranjang belanja",
	orderRemarks: "Catatan Pesanan",
	discountCode: "Silakan masukkan kode promo",
	apply: "Menggunakan",
	submitOrder: "Kirim Pesanan",

	classify: "Kategori",
	price: "Harga",
	allNum: "Total",
	defaultTit: "Default",
	salesLowToHigh: "Penjualan (Rendah - Tinggi)",
	salesHighToLow: "Penjualan (Tinggi - Rendah)",
	nameAtoZ: "Nama (A - Z)",
	nameZtoA: "Nama (Z - A)",
	priceLowtoHeight: "Harga (Rendah - Tinggi)",
	priceHeighttoLow: "Harga (Tinggi - Rendah)",
	selectClassfiy: "Pilih Kategori",
	goodCart: "Keranjang Belanja",
	checkout: "Checkout",
	pay: "Bayar",
	goods: "Produk",
	num: "Jumlah",
	total: "Subtotal",
	action: "Aksi",
	del: "Hapus",
	priceTotal: "Total Harga",
	all: "Semua",
	selectd: "Terpilih",
	goCheckout: "Lanjut ke Pembayaran",
	linkGoods: "Produk Terkait",
	noData: "Tidak ada data",
	myOrder: "Pesanan Saya",
	changeUserInfo: "Ubah Info Pribadi",
	changePassword: "Ubah Kata Sandi",
	myAddress: "Alamat Saya",
	myWishlist: "Favorit Saya",
	myRmas: "Layanan Purna Jual",
	userCommission: "Komisi Member",
	commissionUsers: "Relasi Member",
	loginOut: "Keluar",
	orderId: "Nomor Pesanan",

	lookDetail: "Lihat Detail",
	saleService: "Ajukan Layanan Purna Jual",
	confirmReceivedGoods: "Konfirmasi Penerimaan",
	goPay: "Bayar Sekarang",
	cancelOrder: "Batalkan Pesanan",

	orderDetail: "Detail Pesanan",
	created_at: "Tanggal Pembuatan",
	status_format: "Status Pesanan",
	total_format: "Jumlah Pesanan",
	payment_method_name: "Metode Pembayaran",
	shipping_method_name: "Metode Pengiriman",

	addressInfo: "Info Alamat",
	name: "Nama",
	address: "Alamat",
	payGoods: "Produk yang Dipesan",

	sendCompany: "Kurir",
	sendNum: "Nomor Resi",
	updateTime: "Waktu Update",
	memo: "Catatan",
	payOrderAddress: "Alamat Tagihan",
	allOrder: "Semua Pesanan",
	waitPay: "Menunggu Pembayaran",
	waitSend: "Menunggu Pengiriman",
	waitReceiving: "Menunggu Diterima",
	completed: "Selesai",
	confirm: "Konfirmasi",
	tips: "Tips",
	cancel: "Batal",
	changeHeadImg: "Ubah Foto Profil",
	uploadTit: "Upload gambar JPEG/PNG. Ukuran disarankan 300 x 300.",
	imgSizeTips: "Ukuran gambar tidak boleh lebih dari 2 MB!",
	imgTypeTips: "Format gambar hanya JPG/PNG!",
	serviceType: "Jenis Layanan",
	returnNum: "Jumlah Retur",
	isOpend: "Kemasan dibuka?",
	returnReason: "Alasan Retur",
	yes: "Ya",
	no: "Tidak",
	returnGoods: "Retur Barang",
	exchange: "Tukar Barang",
	repair: "Perbaikan",
	reissue: "Pengiriman Ulang",
	refund: "Hanya Refund",
	returnNumError: "Masukkan jumlah retur",

	oldPassword: "Password Lama",
	newPassword: "Password Baru",
	confirmNewPassword: "Konfirmasi Password Baru",

	wishlist: "Hapus dari Favorit",
	look: "Lihat",
	opendPkg: "Kemasan Terbuka",
	img: "Gambar",
	afterSales: "Detail Layanan Purna Jual",

	balance: "Saldo Tersedia",
	waitAmount: "Jumlah Tertunda",
	withdrawaled: "Telah Ditarik",
	withdrawal: "Penarikan",
	allCommission: "Total Komisi",
	startTime: "Waktu Mulai",
	endTime: "Waktu Selesai",
	search: "Cari",

	rebateLevel: "Tingkat Komisi",
	CommissionRate: "Persentase Komisi",
	commission: "Komisi",
	settlementStatus: "Status Penyelesaian",
	time: "Waktu",
	WithdrawalAmount: "Jumlah Penarikan",
	peleaseSelect: "Silakan Pilih",
	withdrawalUser: "Akun Penarikan",
	peleaseIpt: "Silakan Masukkan",
	submitSuccess: "Berhasil Dikirim",
	shareLink: "Bagikan Tautan",
	superior: "Atasan Langsung",
	wu: "Tidak Ada",
	subordinate: "Bawahan Saya",
	addTime: "Waktu Bergabung",
	userAccount: "Akun",
	recommendationCode: "Kode Referral",
	copySuccess: "Berhasil Disalin",
	subPay: "Ajukan Pembayaran",
	iptCardholder_Name: "Masukkan nama pemilik kartu",

	copy: "salin",

	"home": "Beranda",
	"categoriesPage": "Kategori",
	"brandsPage": "Merek",
	"brandsPageList": "Produk Merek",
	"productsPage": "Produk",
	"wishlistPage": "Favorit Saya",
	"accountPage": "Pesanan Saya",
	"cartsPage": "Keranjang Belanja",
	"checkoutPage": "Pembayaran",
	"passwordPage": "Ubah Kata Sandi",
	"editPage": "Ubah Informasi",
	"addressesPage": "Ubah Alamat",
	"rmasPage": "Hubungan Keanggotaan",
	"commissionPage": "Komisi Anggota",
	"success_order_checkoutPage": "Pembayaran Pesanan",
	"page_categoriesPage": "Kategori Artikel",
	"userloginPage": "Masuk",
	"pagesPage": "Artikel",

	hotGoods: "Produk Populer",
	newGoods: "Produk Terbaru",
	visitGoods: "Paling Banyak Dilihat",
	allGoods: "Semua Produk",
	evaluation: "Ulasan",

	"first_name": "Nama Belakang",
	"first_nameError": "Masukkan nama belakang Anda",
	"last_name": "Nama Depan",
	"last_nameError": "Masukkan nama depan Anda",

	"comment": "Konten",
	"noContent": "Belum ada komentar",
	"author": "Penulis",
	"scoreNum": "Penilaian",
	"commentTit": "Komentar",

	send: "Kirim",
	noPayWay: "Tidak ada metode pembayaran yang tersedia",
	noTransportation: "Tidak ada metode pengiriman yang tersedia",
	
	"tkyouorder": "Terima kasih atas pesanan Anda",
	  "orderDate": "Tanggal Pesanan",
	  "ordeAmount": "Jumlah Pesanan",
	  "paymentAddress": "Alamat Pembayaran",
	  "zipCode": "Kode Pos"

}